import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";

const DEFAULT_LIMIT = 20;

const usePaymentHistory = (brandId) => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });
    const [history, setHistory] = useState([]);
    const [pagination, setPagination] = useState({ total: 0, page: 1, limit: DEFAULT_LIMIT });

    const fetchHistory = async (page = 1, limit = DEFAULT_LIMIT) => {
        const res = await axiosInstance.get(`accounts/v1/${brandId}/payment-history`, { params: { page, limit } });
        const result = res.data || res;
        const items = result.data || result.items || result.results || [];
        setHistory(items);
        setPagination({
            total: result.total ?? items.length,
            page : result.page ?? page,
            limit: result.limit ?? limit
        });
    };

    useEffect(() => {
        fetchHistory(1, DEFAULT_LIMIT);
    }, [brandId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = (limit, page) => fetchHistory(page, limit);
    const handlePerRowsChange = (limit) => fetchHistory(1, limit);

    return { history, pagination, loading, handlePageChange, handlePerRowsChange };
};

export default usePaymentHistory;
